// extracted by mini-css-extract-plugin
module.exports =  {"container":"da51a739f7--container--MknCw","container--size-m":"da51a739f7--container--size-m--X9dbp"};